<div class="universal-filter-bar" *ngIf="showUniversalFilter">
  <!-- Advanced filter toggle button (left side) -->
  <button
    class="filter-toggle-btn"
    (click)="toggleAdvancedFilter($event)"
    [class.active]="isAdvancedOpen"
    pTooltip="Additional Filters"
    tooltipPosition="bottom"
  >
    <svg width="16" height="16">
      <use [attr.xlink:href]="svgPath + 'sprite.svg#default-filter-icon'"></use>
    </svg>
    <span class="filter-applied-dot" *ngIf="hasOverlayFiltersApplied()"></span>
  </button>

  <!-- Inline filter dropdowns (header bar) -->
  <div class="filter-dropdowns">
    <ng-container
      *ngFor="let section of headerSections(); trackBy: trackByFilterName"
    >
      <div
        class="filter-item"
        [ngClass]="'icon-' + section.icon"
        *ngIf="section.type !== 'date'"
      >
        <ng-select
          [formControl]="getFormControl(section.filterName)"
          [items]="section.options || []"
          [loading]="section.isLoading"
          [virtualScroll]="true"
          bindLabel="name"
          (click)="$event.stopPropagation()"
          [placeholder]="section.placeholder"
          appendTo="body"
          [multiple]="section.multiple || false"
          [clearable]="true"
          [searchFn]="customSearchFn"
          (search)="
            onTyping($event, section.methodNameEnding, section.filterName)
          "
          (change)="onFilterChange(section.filterName, $event)"
          (scrollToEnd)="onScrollToEnd(section.methodNameEnding)"
          [closeOnSelect]="false"
          (change)="onSelectChange(section.filterName, $event)"
          (remove)="onChipRemove(section.filterName)"
          (clear)="
            onHeaderFilterClear(section.methodNameEnding, section.filterName)
          "
          (close)="
            onHeaderDropdownClose(section.methodNameEnding, section.filterName)
          "
          onkeypress=""
          class="universal-ng-select"
        >
          <ng-template
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <ng-container *ngIf="!item$.selected">
              <svg width="16" height="16" class="cursor-pointer">
                <use
                  [attr.xlink:href]="
                    svgPath + 'sprite.svg#' + 'checkbox-unselect-dark'
                  "
                ></use>
              </svg>
            </ng-container>
            <ng-container *ngIf="item$.selected"
              ><svg width="16" height="16" class="cursor-pointer">
                <use
                  [attr.xlink:href]="
                    svgPath + 'sprite.svg#' + 'checkbox-select-dark'
                  "
                ></use></svg
            ></ng-container>
            <span class="ng-option-label">{{ item.name }}</span>
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <ng-container *ngFor="let item of items.slice(0, 1)">
              <div
                class="ng-value"
                [pTooltip]="item.name"
                tooltipPosition="top"
              >
                <span class="ng-value-label selection-label">{{
                  item.name
                }}</span>
                <span
                  class="ng-value-icon right"
                  (click)="clear(item)"
                  aria-hidden="true"
                  >×</span
                >
              </div>
            </ng-container>
            <div
              *ngIf="items.length > 1"
              [pTooltip]="tooltipArray(items)"
              tooltipPosition="top"
              class="ng-value"
            >
              <span class="ng-value-label">({{ items.length - 1 }})+</span>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Controlled dropdown shown when date filter is disabled: single "Today" option only -->
      <div
        class="filter-item filter-item-date"
        *ngIf="
          section.type === 'date' &&
          !filterConfig.date &&
          !filterConfig.monthlyCalender
        "
      >
        <span
          class="p-float-label input-container filter-search"
          [ngClass]="'icon-' + section.icon"
        >
          <p-select
            [options]="todayOnlyOptions"
            appendTo="body"
            optionLabel="name"
            [formControl]="getFormControl(section.filterName)"
            panelStyleClass="date-dropdown-panel"
            class="universal-ng-select date-select"
          >
            <ng-template #selectedItem>
              <div class="date-selected-label">
                <div>Today</div>
              </div>
            </ng-template>
          </p-select>
        </span>
      </div>

      <!-- Date type filter -->
      <div
        class="filter-item filter-item-date"
        *ngIf="
          section.type === 'date' &&
          filterConfig.date &&
          !filterConfig.monthlyCalender
        "
      >
        <span
          class="p-float-label input-container filter-search"
          [ngClass]="'icon-' + section.icon"
        >
          <p-select
            placeholder=""
            [options]="filterDateOptions.options"
            appendTo="body"
            optionLabel="name"
            #date
            inputId="float-label"
            [formControl]="getFormControl(section.filterName)"
            (onChange)="getdateselection($event)"
            (click)="$event.stopPropagation()"
            panelStyleClass="date-dropdown-panel"
            class="universal-ng-select date-select"
          >
            <ng-template #selectedItem>
              <div
                class="date-selected-label"
                [pTooltip]="getDateOptionName(date?.value)"
                [tooltipDisabled]="!shouldShowDateTooltip(date?.value)"
                tooltipPosition="top"
              >
                <div>{{ getDateOptionName(date?.value) }}</div>
              </div>
            </ng-template>
            <ng-template #item let-option>
              <div
                class="date-option-label"
                [pTooltip]="getDateOptionName(option)"
                [tooltipDisabled]="!shouldShowDateTooltip(option)"
                tooltipPosition="top"
              >
                {{ getDateOptionName(option) }}
              </div>
            </ng-template>
          </p-select>
          <!-- <label for="float-label">Date</label> -->
        </span>
      </div>
    </ng-container>

    <!-- Monthly Calendar Picker — shown in header bar when monthlyCalender config is true.
         Replaces the regular date-range dropdown; triggers an immediate API call on selection. -->
    <div
      class="filter-item filter-item-date"
      *ngIf="filterConfig.monthlyCalender"
    >
      <app-month-range-picker
        class="calender-monthly"
        [formControl]="getFormControl('monthlyCalender')"
        [minDate]="minDateCalender"
        [maxDate]="maxDateCalender"
        [maxRangeMonths]="3"
        placeholder="Select Month Range"
        (rangeSelect)="onMonthlyCalenderChange()"
      ></app-month-range-picker>
    </div>
  </div>

  <!-- Apply button (right side) -->
  <button class="header-apply-btn" (click)="applyHeaderFilters()">APPLY</button>
</div>

<!-- Custom Date Range Picker Dialog -->
<p-dialog
  class="calenderPopup"
  [(visible)]="customDate"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
>
  <ng-template #header>
    <span class="text-l" *ngIf="defaultDate.length > 0"
      >Start Date: {{ defaultDate[0] | date: 'dd-MM-yyyy HH:mm:ss' }}</span
    >
    <span class="text-l" *ngIf="defaultDate.length > 1"
      >End Date: {{ defaultDate[1] | date: 'dd-MM-yyyy HH:mm:ss' }}</span
    >
  </ng-template>
  <p-datepicker
    [(ngModel)]="selectedDate"
    selectionMode="range"
    [numberOfMonths]="2"
    [readonlyInput]="true"
    [inline]="true"
    [maxDate]="filterDateOptions.max"
    [minDate]="filterDateOptions.min"
    (onSelect)="selectionDate($event)"
  >
  </p-datepicker>
  <app-time-selection
    (timeChange)="handleTimeChange($event)"
    [isTimeVisible]="showTimePicker"
  ></app-time-selection>
  <ng-template #footer>
    <span class="text-l float-start info"
      >Select date range upto {{ filterDateOptions.days }} days</span
    >
    <span class="submitbtn">
      <button (click)="resetDate()" class="btn">Reset</button>
      <button
        (click)="okDate()"
        [disabled]="diff === 0 || diff > filterDateOptions.days"
        class="btn"
      >
        OK
      </button>
    </span>
  </ng-template>
</p-dialog>

<!-- Additional Filters overlay panel -->
<p-popover
  #advancedPanel
  [styleClass]="'universal-advanced-panel columns-' + activeColumnCount()"
  [dismissable]="false"
  (onHide)="onAdvancedPanelHide()"
>
  <ng-template #content>
    <div
      class="overlay-filter-container"
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
    >
      <!-- Header -->
      <div class="overlay-header">
        <h4 class="overlay-title">Additional Filters</h4>
      </div>

      <form [formGroup]="filterForm" class="overlay-form">
        <div class="overlay-body">
          <div
            class="overlay-columns"
            [ngClass]="'cols-' + activeColumnCount()"
          >
            <!-- Location Column -->
            <div class="overlay-column" *ngIf="locationFilters().length > 0">
              <div class="column-heading">Location</div>
              <div class="overlay-fields">
                <div
                  class="overlay-field"
                  [ngClass]="'icon-' + section.icon"
                  [class.disabled-field]="
                    getFormControl(section.filterName).disabled
                  "
                  *ngFor="
                    let section of locationFilters();
                    trackBy: trackByFilterName
                  "
                >
                  <label [attr.for]="section.filterName" class="field-label">{{
                    section.title
                  }}</label>
                  <ng-select
                    [formControl]="getFormControl(section.filterName)"
                    [items]="section.options || []"
                    [loading]="section.isLoading"
                    [virtualScroll]="true"
                    bindLabel="name"
                    (click)="$event.stopPropagation()"
                    [placeholder]="section.placeholder"
                    appendTo="body"
                    [multiple]="section.multiple || false"
                    [clearable]="true"
                    [searchFn]="customSearchFn"
                    (search)="
                      onTyping(
                        $event,
                        section.methodNameEnding,
                        section.filterName
                      )
                    "
                    (change)="onFilterChange(section.filterName, $event)"
                    (scrollToEnd)="onScrollToEnd(section.methodNameEnding)"
                    [closeOnSelect]="false"
                    (change)="onSelectChange(section.filterName, $event)"
                    (clear)="
                      onHeaderFilterClear(
                        section.methodNameEnding,
                        section.filterName
                      )
                    "
                    (close)="
                      onClear(section.methodNameEnding, section.filterName)
                    "
                    [groupBy]="section.groupBy ? section.groupBy : ''"
                    onkeypress=""
                    class="overlay-ng-select"
                    (open)="onDropdownOpen(section)"
                  >
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-item$="item$"
                      let-index="index"
                    >
                      <ng-container *ngIf="!item$.selected">
                        <svg width="24" height="24" class="cursor-pointer">
                          <use
                            [attr.xlink:href]="
                              svgPath + 'sprite.svg#' + 'checkbox-unselect'
                            "
                          ></use>
                        </svg>
                      </ng-container>
                      <ng-container *ngIf="item$.selected"
                        ><svg width="24" height="24" class="cursor-pointer">
                          <use
                            [attr.xlink:href]="
                              svgPath + 'sprite.svg#' + 'checkbox-select'
                            "
                          ></use></svg
                      ></ng-container>
                      <span class="ng-option-label">{{ item.name }}</span>
                    </ng-template>
                    <ng-template
                      ng-multi-label-tmp
                      let-items="items"
                      let-clear="clear"
                    >
                      <ng-container *ngFor="let item of items.slice(0, 1)">
                        <div
                          class="ng-value"
                          [pTooltip]="item.name"
                          tooltipPosition="top"
                        >
                          <span class="ng-value-label selection-label">{{
                            item.name
                          }}</span>
                          <span
                            class="ng-value-icon right"
                            (click)="clear(item)"
                            aria-hidden="true"
                            >×</span
                          >
                        </div>
                      </ng-container>
                      <div
                        *ngIf="items.length > 1"
                        [pTooltip]="tooltipArray(items)"
                        tooltipPosition="top"
                        class="ng-value"
                      >
                        <span class="ng-value-label"
                          >({{ items.length - 1 }})+</span
                        >
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>

            <!-- Vehicle Column -->
            <div class="overlay-column" *ngIf="vehicleFilters().length > 0">
              <div class="column-heading">Vehicle</div>
              <div class="overlay-fields">
                <div
                  class="overlay-field"
                  [ngClass]="'icon-' + section.icon"
                  [class.disabled-field]="
                    getFormControl(section.filterName).disabled
                  "
                  *ngFor="
                    let section of vehicleFilters();
                    trackBy: trackByFilterName
                  "
                >
                  <label [attr.for]="section.filterName" class="field-label">{{
                    section.title
                  }}</label>
                  <ng-select
                    [formControl]="getFormControl(section.filterName)"
                    [items]="section.options || []"
                    [loading]="section.isLoading"
                    [virtualScroll]="true"
                    bindLabel="name"
                    (click)="$event.stopPropagation()"
                    [placeholder]="section.placeholder"
                    appendTo="body"
                    [multiple]="section.multiple || false"
                    [clearable]="true"
                    [searchFn]="customSearchFn"
                    (search)="
                      onTyping(
                        $event,
                        section.methodNameEnding,
                        section.filterName
                      )
                    "
                    (change)="onFilterChange(section.filterName, $event)"
                    (scrollToEnd)="onScrollToEnd(section.methodNameEnding)"
                    [closeOnSelect]="false"
                    (change)="onSelectChange(section.filterName, $event)"
                    (clear)="
                      onHeaderFilterClear(
                        section.methodNameEnding,
                        section.filterName
                      )
                    "
                    (close)="
                      onClear(section.methodNameEnding, section.filterName)
                    "
                    [groupBy]="section.groupBy ? section.groupBy : ''"
                    onkeypress=""
                    class="overlay-ng-select"
                  >
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-item$="item$"
                      let-index="index"
                    >
                      <ng-container *ngIf="!item$.selected">
                        <svg width="24" height="24" class="cursor-pointer">
                          <use
                            [attr.xlink:href]="
                              svgPath + 'sprite.svg#' + 'checkbox-unselect'
                            "
                          ></use>
                        </svg>
                      </ng-container>
                      <ng-container *ngIf="item$.selected"
                        ><svg width="24" height="24" class="cursor-pointer">
                          <use
                            [attr.xlink:href]="
                              svgPath + 'sprite.svg#' + 'checkbox-select'
                            "
                          ></use></svg
                      ></ng-container>
                      <span class="ng-option-label">{{ item.name }}</span>
                    </ng-template>
                    <ng-template
                      ng-multi-label-tmp
                      let-items="items"
                      let-clear="clear"
                    >
                      <ng-container *ngFor="let item of items.slice(0, 1)">
                        <div
                          class="ng-value"
                          [pTooltip]="item.name"
                          tooltipPosition="top"
                        >
                          <span class="ng-value-label selection-label">{{
                            item.name
                          }}</span>
                          <span
                            class="ng-value-icon right"
                            (click)="clear(item)"
                            aria-hidden="true"
                            >×</span
                          >
                        </div>
                      </ng-container>
                      <div
                        *ngIf="items.length > 1"
                        [pTooltip]="tooltipArray(items)"
                        tooltipPosition="top"
                        class="ng-value"
                      >
                        <span class="ng-value-label"
                          >({{ items.length - 1 }})+</span
                        >
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>

            <!-- Source and Specifications Column -->
            <div class="overlay-column" *ngIf="sourceSpecFilters().length > 0">
              <div class="column-heading">Source and Specifications</div>
              <div class="overlay-fields">
                <div
                  class="overlay-field"
                  [ngClass]="'icon-' + section.icon"
                  [class.disabled-field]="
                    getFormControl(section.filterName).disabled
                  "
                  *ngFor="
                    let section of sourceSpecFilters();
                    trackBy: trackByFilterName
                  "
                >
                  <label [attr.for]="section.filterName" class="field-label">{{
                    section.title
                  }}</label>
                  <ng-select
                    [formControl]="getFormControl(section.filterName)"
                    [items]="section.options || []"
                    [loading]="section.isLoading"
                    [virtualScroll]="true"
                    bindLabel="name"
                    (click)="$event.stopPropagation()"
                    [placeholder]="section.placeholder"
                    appendTo="body"
                    [multiple]="section.multiple || false"
                    [clearable]="true"
                    [searchFn]="customSearchFn"
                    (search)="
                      onTyping(
                        $event,
                        section.methodNameEnding,
                        section.filterName
                      )
                    "
                    (change)="onFilterChange(section.filterName, $event)"
                    (scrollToEnd)="onScrollToEnd(section.methodNameEnding)"
                    [closeOnSelect]="false"
                    (change)="onSelectChange(section.filterName, $event)"
                    (clear)="
                      onHeaderFilterClear(
                        section.methodNameEnding,
                        section.filterName
                      )
                    "
                    (close)="
                      onClear(section.methodNameEnding, section.filterName)
                    "
                    [groupBy]="section.groupBy ? section.groupBy : ''"
                    onkeypress=""
                    class="overlay-ng-select"
                  >
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-item$="item$"
                      let-index="index"
                    >
                      <ng-container *ngIf="!item$.selected">
                        <svg width="24" height="24" class="cursor-pointer">
                          <use
                            [attr.xlink:href]="
                              svgPath + 'sprite.svg#' + 'checkbox-unselect'
                            "
                          ></use>
                        </svg>
                      </ng-container>
                      <ng-container *ngIf="item$.selected"
                        ><svg width="24" height="24" class="cursor-pointer">
                          <use
                            [attr.xlink:href]="
                              svgPath + 'sprite.svg#' + 'checkbox-select'
                            "
                          ></use></svg
                      ></ng-container>
                      <span class="ng-option-label">{{ item.name }}</span>
                    </ng-template>
                    <ng-template
                      ng-multi-label-tmp
                      let-items="items"
                      let-clear="clear"
                    >
                      <ng-container *ngFor="let item of items.slice(0, 1)">
                        <div
                          class="ng-value"
                          [pTooltip]="item.name"
                          tooltipPosition="top"
                        >
                          <span class="ng-value-label selection-label">{{
                            item.name
                          }}</span>
                          <span
                            class="ng-value-icon right"
                            (click)="clear(item)"
                            aria-hidden="true"
                            >×</span
                          >
                        </div>
                      </ng-container>
                      <div
                        *ngIf="items.length > 1"
                        [pTooltip]="tooltipArray(items)"
                        tooltipPosition="top"
                        class="ng-value"
                      >
                        <span class="ng-value-label"
                          >({{ items.length - 1 }})+</span
                        >
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /overlay-body -->

        <!-- Fixed Footer -->
        <div class="overlay-footer">
          <button
            type="button"
            class="btn-clear-selection"
            (click)="clearAllFilters()"
          >
            Clear Selection
          </button>
          <button type="button" class="btn-apply" (click)="applyFilters()">
            APPLY
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</p-popover>
